export const ARROWS = ['prev', 'next'] as const;

export const TEST_ID_PRICE_CHART_PREVIEW = 'test-id-price-chart-preview';
export const TEST_ID_PRICE_CHART_CONTAINER = 'test-id-price-chart-container';

// Массив высот колонок для скелетонов
export const RANDOM_COLUMNS = [
  21, 32, 28, 28, 23, 17, 11, 15, 41, 15, 32, 28, 23, 28, 34, 20, 34, 28, 28,
  28, 32, 21, 15, 34, 15, 25, 11, 28, 23, 23, 23, 32, 41, 28, 28, 21,
] as const;
